const envelopeNameSummary = (envelopes: Array<{ name: string }>) => {
    return envelopes
        .map((envelope) => {
            return envelope.name;
        })
        .join(', ');
};

export default envelopeNameSummary;
